// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "global": {
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      },
      "name": "global",
      "selected_by_default": null,
      "translated": false
    },
    "height_mm": {
      "column": {
        "default": null,
        "name": "height_mm",
        "null": false,
        "type": "integer"
      },
      "name": "height_mm",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "width_mm": {
      "column": {
        "default": null,
        "name": "width_mm",
        "null": false,
        "type": "integer"
      },
      "name": "width_mm",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "SheetSize",
  "collectionKey": "sheet_sizes",
  "collectionName": "sheet_sizes",
  "i18nKey": "sheet_size",
  "camelizedLower": "sheetSize",
  "name": "SheetSize",
  "nameDasherized": "sheet-size",
  "pluralName": "sheet_sizes",
  "ransackable_associations": [
    {
      "className": "SheetSize::Translation",
      "collectionName": null,
      "foreignKey": "sheet_size_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "sheet_size_id",
      "name": "photo_sheet_product_order_lines",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_size_id",
      "name": "sheet_layouts",
      "macro": "has_many",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "SupplierSupportedSheet",
      "collectionName": "supplier_supported_sheets",
      "foreignKey": "sheet_size_id",
      "name": "supplier_supported_sheets",
      "macro": "has_many",
      "resource_name": "SupplierSupportedSheet",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "SheetSize::Translation",
      "collectionName": null,
      "foreignKey": "sheet_size_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "global",
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "height_mm",
      "column": {
        "default": null,
        "name": "height_mm",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "width_mm",
      "column": {
        "default": null,
        "name": "width_mm",
        "null": false,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "sheet_size",
  "primaryKey": "id"
}

/** Frontend model for SheetSize. */
export default class SheetSize extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  global() {
    return this.readAttributeUnderscore("global")
  }

  /** @returns {boolean} */
  hasGlobal() {
    const value = this.global()

    return this._isPresent(value)
  }

  /** @returns {number} */
  heightMm() {
    return this.readAttributeUnderscore("height_mm")
  }

  /** @returns {boolean} */
  hasHeightMm() {
    const value = this.heightMm()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {number} */
  widthMm() {
    return this.readAttributeUnderscore("width_mm")
  }

  /** @returns {boolean} */
  hasWidthMm() {
    const value = this.widthMm()

    return this._isPresent(value)
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
